/*
 * @Author: Song Xingyun
 * @Date: 2021-07-09 15:54:34
 * @LastEditors: Song Xingyun
 * @LastEditTime: 2021-07-10 15:56:19
 * @FilePath: /vue-modv/src/@core/directives/index.js
 * @Description:
 */
import longpress from './longPress'
import { heightFade } from './animations'

const directives = {
  longpress,
  heightFade
}

export default {
  install(Vue) {
    Object.keys(directives).forEach(key => {
      Vue.directive(key, directives[key])
    })
  }
}
